import React, { createRef, useEffect, useState } from 'react';
import { useBookContext } from '../../BookContext';
import BookChapterCustom from './BookChapterCustom';
import { useSearchParams } from 'react-router-dom';
import BookChapterDetailCustom from './BookChapterDetailCustom';
import BookExtraResourceCustom from './BookExtraResourceCustom';
import config from '../../../../../common-sk-doc/src/config';
import { defaultImage, getUrlBookCover } from '../../../../../common-sk-doc/src/utils/image';

const BookViewCustom: React.FC = () => {
// const BookViewCustom = () => {
  const {
    book,
    extraResourceGroups,
  } = useBookContext();
  const [searchParams] = useSearchParams();
  const chapterId = searchParams.get('chapter');
  const ref = createRef<HTMLDivElement>();

  const [firstColumns, setFirstColumns] = useState(null);
  const [secondColumns, setSecondColumns] = useState(null);
  useEffect(() => {
    let _chapters = JSON.parse(JSON.stringify(book.chapters));
    let arrStart = _chapters.filter((_, i) => i < _chapters.length / 2);
    let arrEnd = _chapters.filter((_, i) => i >= _chapters.length / 2);
    setFirstColumns(arrStart);
    setSecondColumns(arrEnd);
  }, [book]);
  return (
    <div className="book-page-wrapper">
      <div className="container">
        <div className="book-page-custom">
          <div className="book-detail">
            <div className="book-detail-left">
              <div className="book-image-title" />
              {!chapterId ? (
                <div className="list-chapter appear" ref={ref}>
                  {firstColumns && (
                    <div className="bookview-column">
                      {firstColumns.map((c, i) => (
                        <BookChapterCustom
                          key={i}
                          chapters={book.chapters}
                          chapter={c}
                          index={i}
                        />
                      ))}
                    </div>
                  )}
                  {secondColumns && (
                    <div className="bookview-column">
                      {secondColumns.map((c, i) => (
                        <BookChapterCustom
                          key={i}
                          chapters={book.chapters}
                          chapter={c}
                          index={i + firstColumns.length}
                        />
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <BookChapterDetailCustom
                  chapterId={chapterId}
                />
              )}
            </div>
            <div className="book-detail-right">
              <div className="book-cover">
                <div className="text-center position-relative">
                  <img
                    className="book-img"
                    src={getUrlBookCover(book)}
                    onError={(e) =>
                      defaultImage(
                        e,
                        config.ASSETS_PATH +
                          '/images/home/default_book.svg',
                      )
                    }
                    alt=""
                  />
                </div>
              </div>
              <div className="book-extension">
                {extraResourceGroups.map((extra, index) => (
                  <BookExtraResourceCustom extraResourceGroup={extra} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookViewCustom;
